import { useFlags } from 'launchdarkly-react-client-sdk'

export function useAppointmentNoteFormRxFieldsEnabled(): boolean {
  const { appointmentNoteFormRxFields } = useFlags()
  return Boolean(appointmentNoteFormRxFields)
}
